@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/mixins/common" as m;

.demurrageWrapper {
  height: 100%;

  ul {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
  }

  li {
    background-color: v.$palette-gray-100;
    border-radius: 10px;
  }
}

.demurrage {
  margin-bottom: 8px;
}

.row {
  display: flex;
  height: 50px;

  border-top: 1px solid v.$palette-gray-300;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    @include t.text(14px, 22px, 400);
    @include m.containerMedia(v.$js-defined-mobile-breakpoint, "min") {
      padding: 14px 16px;
    }
  }

  &.titleRow {
    border-top: none;
    div {
      display: flex;
      align-items: center;
      justify-content: center;
      @include t.text(14px, 22px, 600);
    }
  }

  & div:first-child {
    display: flex;
    align-items: center;
    justify-content: start;
  }

  .col {
    width: 33%;
  }
}

.errorWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.not-available-bold {
  @include t.text(16px, 20px, 600);
  text-align: center;
}
